import { SectionNameType } from './events';
import { TagType, TrackingWrapper } from './TrackingWrapper';

type Props = {
  sectionName: SectionNameType;
  as?: TagType;
  className?: string;
};

export const withTracking = <T extends object>(
  Component: React.ElementType,
  { sectionName, as, className }: Props,
) => (props: T) => {
  return (
    <TrackingWrapper as={as} className={className} sectionName={sectionName}>
      <Component {...props} />
    </TrackingWrapper>
  );
};
